import { FC, ReactNode, useMemo } from 'react';

import _merge from 'lodash/merge';

interface SEOProps {
  title: string;
  excludeTitleEnd?: boolean;
  description: string;
  keywords?: string[];
  images?: string[];
  headline?: string;
  opengraph?: { [key: string]: string };
  children?: ReactNode;
}

export const SEO: FC<SEOProps> = (props) => {
  const { title, excludeTitleEnd, description, keywords, images, opengraph: opengraphProps, children } = props;
  const titleText = excludeTitleEnd ? title : `${title} | Arrived Homes`;

  const opengraph = useMemo(() => {
    return _merge(
      {},
      {
        'og:title': title,
        'og:description': description,
        'og:image': images && images.length > 0 ? images[0] : undefined,
        'twitter:title': title,
        'twitter:description': description,
        'twitter:image': images && images.length > 0 ? images[0] : undefined,
      },
      opengraphProps
    );
  }, [title, description, images, opengraphProps]);

  return (
    <>
      <title>{titleText}</title>

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      {description && <meta name="description" content={description} />}
      <meta name="application-name" content="Arrived Homes" />
      <meta name="image" content={images?.[0]} />
      {keywords && <meta name="keywords" content={keywords.join(',')} />}

      {Object.entries(opengraph).map(([name, content]) => {
        return <meta key={name} property={name} content={content} />;
      })}
      {children}
    </>
  );
};
